<template>
    <div v-show="state.showModel == 'list'">
        <div class="table-page-search-wrapper">
            <a-form>
                <a-row :gutter="48">
                    <a-col :md="8" :sm="24">
                        <a-form-item label="标题">
                            <a-input v-model:value="queryParam.title" placeholder="请输入标题"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="8" :sm="24">
                        <span class="table-page-search-submitButtons">
                            <a-button type="primary" @click="loadData">查询</a-button>
                            <a-button style="margin-left: 8px" @click="refreshTabel">重置</a-button>
                        </span>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
            @change="onChange">
            <template #bodyCell="{ column, record, index, text }">
                <template v-if="column.dataIndex === 'title'">
                    <a @click="handleInfo(record)">
                        {{ record.title }}
                    </a>
                </template>
                <template v-else-if="column.dataIndex == 'is_read'">
                    <a-tag color="green" v-if="record.is_read > 0">已读</a-tag>
                    <a-tag color="red" v-else>未读</a-tag>
                </template>
            </template>
        </a-table>
    </div>
    <div v-show="state.showModel == 'info'">
        <h2 style="text-align: center; margin: 10px auto">{{ state.detailData.title }}</h2>
        <div style="text-align: center; margin: 10px auto">发布时间：{{ state.detailData.created_at }}</div>
        <div style="margin: 10px auto" class="detailDatabody" v-html="state.detailData.body" @click="handleImageClick">
        </div>
    </div>
    <!-- <NewsInfo v-if="state.showInfo" :detailData="state.detailData" @cancel="cancel" @ok="onOk"></NewsInfo> -->
    <a-image :width="200" :style="{ display: 'none' }" :preview="{
        visible: state.previewVisible,
        onVisibleChange: setVisible
    }" :src="state.previewImage" />
</template>

<script lang="ts" setup>
import { PlusOutlined } from '@ant-design/icons-vue'
import type { PaginationProps } from 'ant-design-vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { ref, reactive, onMounted, h, watch } from 'vue'
import NewsInfo from './NewsInfo.vue'
const emit = defineEmits(['showzw'])
const props = defineProps({
    catid: {
        type: Number,
        default: 0
    }
})
const columns = [
    {
        title: '标题',
        dataIndex: 'title'
    },
    {
        title: '阅读状态',
        dataIndex: 'is_read',
        width: '100px'
    },
    {
        title: '创建时间',
        dataIndex: 'created_at',
        width: '120px'
    }
]
interface data {
    showInfo: boolean
    detailData: any
    loading: boolean
    showModel: string
    previewImage: string
    previewVisible: boolean
}
const state = reactive<data>({
    showInfo: false,
    detailData: {},
    loading: false,
    showModel: 'list',
    previewImage: '',
    previewVisible: false
})
interface queryParam {
    title?: string
}
let param = ref<queryParam>({ title: '' })
let queryParam = param.value
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '20', '30', '40'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    state.showModel = 'list'
    loadData()
})
watch(
    () => props.catid,
    (val) => {
        //改变分类，重置表单重新加载数据
        state.showModel = 'list'
        refreshTabel()
    }
)
const refreshTabel = () => {
    pagination.current = 1
    param.value = {}
    queryParam = param.value
    loadData()
}
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/newsMyList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, cat_id: props.catid }, queryParam)
    }
    baseService(requestParam)
        .then((res) => {
            state.loading = false
            pagination.total = res.data.total_records
            dataSource.value = res.data.list.map((item) => ({ ...item, isShowOptions: false }))
        })
        .catch((res) => {
            state.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取列表失败')
            }
        })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const handleInfo = (record) => {
    state.showInfo = true
    state.showModel = 'info'
    state.detailData = { ...record }
    //处理一下图片，正则去掉img标签的style
    state.detailData.body = state.detailData.body.replace(/<img[^>]*>/gi, (imgTag) => {
        // 检查是否是SVG图片
        if (imgTag.includes('.svg') || imgTag.includes('.svg?')) {
            return imgTag // 如果是SVG，保持原样不处理
        }

        // 非SVG图片：去掉style属性并添加新样式
        const cleanTag = imgTag.replace(/\s*style\s*=\s*["'][^"']*["']/gi, '')
        return cleanTag.replace('<img', '<img style="max-width:100%;height:auto;"')
    })
    //查询一下详情，让其变成已读
    queryDetail(record.id)
    emit('showzw', true)
}
const cancel = () => {
    state.showModel = 'list'
    state.showInfo = false
}
const onOk = () => {
    state.showModel = 'list'
    state.showInfo = false
    loadData()
}
// 暴露方法给父组件
defineExpose({
    onOk: onOk
})
const queryDetail = (id) => {
    let requeryParam = {
        url: `/admin/v1/news/${id}/info`,
        method: 'get'
    }
    baseService(requeryParam).then((res) => { })
}
const handleImageClick = (e) => {
    // 检查点击的是否是图片
    if (e.target.tagName === 'IMG') {
        const img = e.target
        console.log('点击了图片:', img.src)
        console.log('alt属性:', img.alt)
        console.log('自定义数据:', img.dataset.src)

        // 在这里处理图片点击逻辑
        setVisible(true, img.src)
    }
}
//预览
const setVisible = (value, url): void => {
    if (value) {
        state.previewImage = url
        state.previewVisible = true
    } else {
        state.previewVisible = false
    }
}
</script>

<style lang="less" scoped>
.detailDatabody {
    :deep(img) {}
}
</style>
